import { addCommasToNumber } from '../../../../Utils/CommonUtils';

interface IEMI_FORMULA {
  loanAmount: number | null;
  rateOfInterest: number | null;
  noOfMonths: number | null;
  currentMonth: number | null;
}

export interface RETURN_EMI_MONTHLY_DATA {
  [key: string]: string;
  year: string;
  month: string;
  emiPayable: string;
  totalLoanAmount: string;
  beginningBalance: string;
  interest: string;
  principal: string;
  endingBalance: string;
  emi: string;
}

export const EMI_MONTHLY_DETAILS = ({
  loanAmount,
  rateOfInterest,
  noOfMonths,
}: IEMI_FORMULA) => {
  if (!loanAmount || !rateOfInterest || !noOfMonths) return;

  const emiDetails: Record<string, unknown>[] = [];
  const monthlyInterestRate = rateOfInterest / 100 / 12;
  let currentYear = new Date().getFullYear();
  let currentMonth = new Date().getMonth();

  if (currentMonth === 12) {
    currentMonth = 0;
    currentYear++;
  }

  for (let monthIndex = 0; monthIndex < noOfMonths; monthIndex++) {
    const monthOfYear = (currentMonth + monthIndex) % 12 || 12;
    const year = currentYear + Math.floor((currentMonth + monthIndex) / 12);

    const beginningBalance: number =
      monthIndex === 0
        ? Number(loanAmount)
        : Number(emiDetails[emiDetails.length - 1]?.endingBalance);

    const emi =
      (loanAmount *
        monthlyInterestRate *
        Math.pow(1 + monthlyInterestRate, noOfMonths)) /
      (Math.pow(1 + monthlyInterestRate, noOfMonths) - 1);

    const interest = beginningBalance * monthlyInterestRate;
    const principal = Number(emi.toFixed(2)) - Number(interest.toFixed(2));
    const endingBalance = beginningBalance - Number(principal.toFixed(2));

    emiDetails.push({
      year: year.toString(),
      month: getMonthName(year, monthOfYear),
      emiPayable: addCommasToNumber(emi, 0),
      totalLoanAmount: Number(loanAmount).toFixed(0),
      beginningBalance: Number(beginningBalance).toFixed(0),
      interest: Number(interest).toFixed(0),
      principal: Number(principal).toFixed(0),
      endingBalance: Number(endingBalance < 0 ? 0 : endingBalance).toFixed(0), //TODO: fix logic
      emi: Number(emi).toFixed(0),
    });
  }
  return emiDetails;
};

const getMonthName = (year: number, month: number) => {
  return new Date(year, month, 1).toLocaleString('default', {
    month: 'short',
  });
};
